import { randFullName } from '@ngneat/falso';

import { ExternalInfos } from '@/domain/external/entities/external.entity';
import { ExternalGateway } from '@/domain/external/gateway/external.gateway';
import {
  Scope,
  Status,
} from '@/domain/external-invitation/entities/external-invitation.entity';
import { Sector } from '@/domain/impact/impact.entity';

export class ApiExternalFakeGateway implements ExternalGateway {
  async getExternalInfos(code: string): Promise<ExternalInfos> {
    await new Promise((r) => setTimeout(r, 300));

    // 👨‍💻 dev - normal case
    const index = FAKE_EXTERNAL.findIndex((x) => x.code === code);
    if (index !== -1) {
      return FAKE_EXTERNAL[index];
    } else {
      throw 'not found';
    }

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  async updateExternalInvitation(
    externalInfos: ExternalInfos,
    status: Status,
    completion: number,
  ): Promise<void> {
    console.log('🤖 do nothing in fake', externalInfos, status, completion);
  }
}

// THESE FAKE SHOULD MATCH DATA IN api-external-invitation-fake

const FAKE_EXTERNAL: ExternalInfos[] = [
  // FESTIVAL
  buildExternalInfos({ code: '101', sector: 'TEAM', scope: 'TEAM' }),
  buildExternalInfos({ code: '102', sector: 'ARTISTS', scope: 'ARTISTS' }),
  buildExternalInfos({
    code: '103',
    sector: 'PUBLIC',
    scope: 'PUBLIC_SUPPLIER',
  }),
  buildExternalInfos({ code: '104', sector: 'SITE', scope: 'SITE' }),
  // FESTIVAL-CATEGORIES
  buildExternalInfos({
    code: '106',
    sector: 'TEAM',
    scope: 'TEAM-MOBILITY',
  }),
  buildExternalInfos({
    code: '107',
    sector: 'TEAM',
    scope: 'TEAM-CATERING',
  }),
  // VENUE-STRUCTURE
  buildExternalInfos({
    code: '201',
    sector: 'SITE',
    scope: 'VENUE-STRUCTURE-SITE',
  }),
  buildExternalInfos({
    code: '202',
    sector: 'TEAM',
    scope: 'VENUE-STRUCTURE-TEAM',
  }),
  // VENUE-STRUCTURE-CATEGORIES
  buildExternalInfos({
    code: '2011',
    sector: 'SITE',
    scope: 'VENUE-STRUCTURE-SITE-SCENOGRAPHY',
  }),
  // VENUE-DATES
  buildExternalInfos({
    code: '203',
    sector: 'ARTISTS',
    scope: 'VENUE-DATES-ARTISTS',
  }),
  // VENUE-DATES CATEGORIES
  buildExternalInfos({
    code: '2031',
    sector: 'ARTISTS',
    scope: 'VENUE-DATES-ARTISTS-CARGO',
  }),
];

function buildExternalInfos({
  code,
  sector,
  scope,
}: {
  code: string;
  sector: Sector;
  scope: Scope;
}): ExternalInfos {
  return {
    id: 0,
    code: code,
    userName: randFullName(),
    sector: sector,
    scope: scope,
    expirationDate: '2025-12-30T19:21:44.000Z',
    eventPosition: undefined,
    title: `Custom title`,
    projectId: 9,
    completion: 0.25,
    status: 'IN_PROGRESS',
    isValidated: false,
    projectInfos: {
      name: `The project 🟦 ${sector} 🟦`,
      location: 'Caen',
      image:
        'https://cc-prod.scene7.com/is/image/CCProdAuthor/how_to_compress_images_with_photoshop_lightroom_P1_mobile_360x270?$pjpeg$&jpegSize=200&wid=720',
      startDate: '2023-11-30T19:21:44.000Z',
      endDate: '2024-03-22T19:21:44.000Z',
    },
  };
}
